import * as Sentry from "@sentry/react";
import instrumentSentry from "./sentry/instrument";

instrumentSentry(Sentry, "jsx");

export { Sentry };
